import React, { useRef } from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NextArrowIcon from "../../../styles/images/nextArrow.png";
import PrevArrowIcon from "../../../styles/images/prevArrow.png"

export default function UiSlider(props) {


    function NextArrow(props) {
        const { className, style, onClick } = props;

        return (
            <div
                className={className}
                style={{ ...style, display: "block" }}
                onClick={onClick}
            >
                <img src={NextArrowIcon} />
            </div>
        );
    }

    function PrevArrow(props) {
        const { className, style, onClick } = props;

        return (
            <div
                className={className}
                style={{ ...style, display: "block" }}
                onClick={onClick}
            >
                <img src={PrevArrowIcon} />

            </div>
        );
    }


    const settings = {
        dots: props.dots,
        infinite: props.infinite,
        speed: 500,
        slidesToShow: props.slidesToShow,
        slidesToScroll: 1,
        variableWidth: props.variableWidth,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />
    };

    return (
        <>
            <div className="slider-container">
                <Slider {...settings}
                >
                    {props.children}
                </Slider>
            </div>

        </>
    )
}
